import { AddressType } from '../../types/AddressType';
import addressFormatter from './addressFormatter';

export default function shortAddress(address: AddressType) {
  return addressFormatter(address, ['street1', 'street2', 'city']);
}
